import React from 'react';

import { useStipReport } from '../../hooks/use-stip-report';
import { useFetchServiceTypes } from '../../hooks/fetch/use-fetch-service-types';
import { useFetchDocumentTypes } from '../../hooks/fetch/use-fetch-document-types';
import { useFetchFilteredCompaniesByLine } from '../../hooks/fetch/use-fetch-filtered-companies-by-line';

import Loading from '../../../../layouts/Loading';
import { GridItem } from '../../components/GridItem';
import { ReportDatePicker } from '../../components/ReportDatePicker';
import { ReportSectionTitle } from '../../components/ReportSectionTitle';
import { ReportMultiAutocomplete } from '../../components/ReportMultiAutocomplete';

const SOMENTE_STRIP = { boStrip: true };

const DocumentReport = () => {
  const { handleSelectChange } = useStipReport();

  const { loading: loadinServiceTypes, serviceTypes } = useFetchServiceTypes();
  const { loading: loadingDocumentTypes, documentTypes } = useFetchDocumentTypes();
  const { lines, companies, loading: loadingCompanies } = useFetchFilteredCompaniesByLine(SOMENTE_STRIP);

  let loading = loadinServiceTypes || loadingDocumentTypes || loadingCompanies;

  if (loading) {
    return <Loading />;
  }

  return (
    <GridItem container spacing={3}>
      <GridItem sm={6}>
        <ReportSectionTitle gutterBottom>Selecione a(s) linha(s) / serviço(s):</ReportSectionTitle>
        <ReportMultiAutocomplete
          options={lines}
          disabled={lines.length === 0}
          onSelect={handleSelectChange}
          label={lines.length === 0 ? 'Não há linhas disponíveis' : 'Todos as linhas / serviços'}
          name="linhas"
          valueProperty="cdLinha"
          labelProperty="deDescricao"
          limitTags={1}
        />
      </GridItem>
      <GridItem sm={6}>
        <ReportSectionTitle gutterBottom>Selecione a(s) empresa(s):</ReportSectionTitle>
        <ReportMultiAutocomplete
          options={companies}
          onSelect={handleSelectChange}
          label="Todas as empresas"
          name="empresas"
          valueProperty="cdEmpresa"
          labelProperty="deRazaoSocial"
          getOptionLabel={option =>
            Boolean(option.deRazaoSocial) ? option.deRazaoSocial : option.nmCompleto
          }
          limitTags={1}
        />
      </GridItem>

      <GridItem>
        <ReportSectionTitle divider />
      </GridItem>
      <GridItem>
        <ReportSectionTitle>Filtrar por data do documento:</ReportSectionTitle>
      </GridItem>
      <GridItem sm={3}>
        <ReportDatePicker label="Data inicial" name="dtCadastro.dtInicio" />
      </GridItem>
      <GridItem sm={3}>
        <ReportDatePicker label="Data final" name="dtCadastro.dtFim" />
      </GridItem>

      <GridItem>
        <ReportSectionTitle divider />
      </GridItem>
      <GridItem sm={6}>
        <ReportSectionTitle gutterBottom>Selecione o(s) tipo(s) de serviço(s):</ReportSectionTitle>
        <ReportMultiAutocomplete
          options={serviceTypes}
          onSelect={handleSelectChange}
          label="Todos os tipos de serviços"
          name="tiposServico"
          valueProperty="cdTipoServico"
          labelProperty="deTipoServico"
        />
      </GridItem>
      <GridItem sm={6}>
        <ReportSectionTitle gutterBottom>
          Selecione o(s) tipo(s) de documento(s):
        </ReportSectionTitle>
        <ReportMultiAutocomplete
          options={documentTypes}
          onSelect={handleSelectChange}
          label="Todos os tipos de documento"
          name="tiposDocumento"
          valueProperty="cdTipoDocumento"
          labelProperty="deTipoDocumento"
        />
      </GridItem>
    </GridItem>
  );
};

export default DocumentReport;
